import { useId, useState, type FormEvent } from 'react';

import { ApiError } from '../../api/client';
import {
  Alert,
  Button,
  Card,
  FormField,
  Input,
  PageHeader,
  PageLayout,
  PasswordInput,
  Section,
} from '../../components';
import { useI18n } from '../../i18n';
import { useSession } from '../../auth/session-context';

/**
 * Anmeldung der Systemadministration (01_roles_and_accounts.md).
 *
 * Eigene Adresse und eigener Endpunkt: ein Hauptadmin gehoert zu keinem
 * Mandanten. Von der Kundenanmeldung fuehrt bewusst kein Link hierher - wer
 * hier hingehoert, kennt die Adresse.
 */
export function PlatformLoginPage(): JSX.Element {
  const { t, tError } = useI18n();
  const { loginPlatform } = useSession();
  const emailId = useId();
  const passwortId = useId();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const anmelden = (event: FormEvent): void => {
    event.preventDefault();
    void (async () => {
      setError(null);
      setBusy(true);
      try {
        await loginPlatform(email, password);
      } catch (caught) {
        setError(caught instanceof ApiError ? tError(caught.code) : tError(undefined));
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <PageLayout width="schmal">
      <PageHeader title={t('login.platformTitle')} />

      <Card>
        <Section>
          {error ? <Alert tone="error">{error}</Alert> : null}

          <form onSubmit={anmelden} className="form">
            <FormField label={t('login.email')} htmlFor={emailId}>
              <Input
                id={emailId}
                type="email"
                value={email}
                onChange={setEmail}
                autoComplete="username"
              />
            </FormField>
            <FormField label={t('login.password')} htmlFor={passwortId}>
              <PasswordInput id={passwortId} value={password} onChange={setPassword} />
            </FormField>

            <Button type="submit" variant="primary" block disabled={busy}>
              {t('action.login')}
            </Button>
          </form>
        </Section>
      </Card>
    </PageLayout>
  );
}
